import React, { useEffect, useState } from 'react';
import { useReadContract, useWaitForTransactionReceipt, useWriteContract } from 'wagmi';
import MforgePriceAbi from '../../Utils/ABI/MforgePrice.json';
import { formatEther, parseEther } from 'viem';
import ValidatorAbi from '../../Utils/ABI/ValidatorAbi.json';
import { toast } from 'react-toastify';
import { RxCross2 } from 'react-icons/rx';
import axios from 'axios';
import '../../components/PopUpModal/TxMigrationTable.css';


export default function AddOffChainModal({ isOpen, onClose, type }) {
    const [loader, setLoader] = useState(false);

    const tierMap = {
        1: 500,
        2: 1000,
        3: 5000,
        4: 10000
    }

    const [form, setForm] = useState({
        walletAddress: "",
        amount: type === "validator" ? 500 : 0,
        bonusCat: 1,
        startDate: "",
        type: type || "validator",
        tier: 1
    })

    const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
    const BASE_URL = environment === 'production' 
      ? process.env.REACT_APP_PROD_API_URL 
      : environment === 'staging' 
        ? process.env.REACT_APP_STAG_API_URL 
        : process.env.REACT_APP_DEV_API_URL || 'http://localhost:4001';


    const [calculation, setCalculation] = useState({
        principle: "",
        bonus: ""
    })

    const { data: stakeHash, writeContractAsync: stakeWrite } = useWriteContract();
    const { isSuccess: isstakeSuccess } = useWaitForTransactionReceipt({ hash: stakeHash });

    const { data: epochInfo } = useReadContract({
        address: process.env.REACT_APP_VEL_DEL_ADDRESS,
        abi: ValidatorAbi,
        functionName: "getEpochInfo",
        query: {
            refetchInterval: 5000
        }
    })

    const { data: mforgePrice } = useReadContract({
        address: process.env.REACT_APP_MFORE_PRICE,
        abi: MforgePriceAbi,
        functionName: "getMforgePriceInUSD",
        args: [
            process.env.REACT_APP_MFORGE_PAIR
        ],
        query: {
            refetchInterval: 5000
        }
    })

    useEffect(() => {
        if (mforgePrice && form.amount) {
            const price = Number(formatEther(mforgePrice));
            const principle = Number(form.amount) / price;
            const bonus = principle * Number(form.bonusCat);
            setCalculation({
                principle: principle,
                bonus: bonus
            })
        } else {
            setCalculation({
                principle: "",
                bonus: ""
            })
        }
    }, [mforgePrice, form.amount, form.bonusCat])

    const handleChange = ({ target: { name, value } }) => {
        setForm(prev => {
            const updatedForm = {
                ...prev,
                [name]: value
            }

            if (name === "tier" && prev.type === "validator") {
                updatedForm.amount = tierMap[value];
            }
            if (name === "type" && value === "validator") {
                updatedForm.amount = tierMap[updatedForm.tier || 1];
            }

            return updatedForm;
        })
    }

    const handleSubmit = async () => {
        if (!form.walletAddress || !form.amount || !form.startDate) {
            toast.error("Please fill all fields");
            return;
        }

        if (!form.walletAddress.startsWith("0x") || form.walletAddress.length !== 42) {
            toast.error("Invalid wallet address");
            return;
        }

        if (Number(form.amount) <= 0) {
            toast.error("Amount must be greater than 0");
            return;
        }

        if (!calculation.principle || isNaN(calculation.principle)) {
            toast.error("Calculation pending, please wait or re-enter amount");
            return;
        }

        setLoader(true);
        try {
            const secondArg = form.type === "validator" ? form.tier.toString() : parseEther(form.amount.toString()).toString();

            await stakeWrite({
                address: process.env.REACT_APP_VEL_DEL_ADDRESS,
                abi: ValidatorAbi,
                functionName: form.type === "validator" ? "migrateOffChainValidator" : "migrateOffChainDelegator",
                args: [
                    form.walletAddress,
                    secondArg,
                    parseEther(calculation.principle.toString()).toString(),
                    parseEther(form.bonusCat.toString()).toString(),
                    Math.floor(new Date(form.startDate).getTime() / 1000)
                ]
            })
        } catch (error) {
            console.log(error);
            setLoader(false);
            toast.error(error.shortMessage || "Transaction failed");
        }
    }

    useEffect(() => {
        const handleSync = async () => {
            if (isstakeSuccess && stakeHash) {
                try {
                    await axios.post(`${BASE_URL}/v1/validator-delegator/sync-stake`, {
                        ...form,
                        transactionHash: stakeHash,
                        mforgePrice: mforgePrice ? Number(formatEther(mforgePrice)) : 0
                    }, {
                        headers: {
                            "Authorization": `Bearer ${localStorage.getItem("acessToken")}`
                        }
                    });
                    toast.success("Stake Synchronized with Backend");
                } catch (err) {
                    console.error("Backend Sync Failed:", err);
                    toast.warning("Stake successful on-chain, but failed to sync with backend database. Please contact admin.");
                } finally {
                    setLoader(false);
                    onClose();
                    setForm({
                        walletAddress: "",
                        amount: type === "validator" ? 500 : 0,
                        bonusCat: 1,
                        startDate: "",
                        type: type || "validator",
                        tier: 1
                    });
                    setCalculation({
                        principle: "",
                        bonus: ""
                    });
                }
            }
        };

        if (isstakeSuccess) {
            toast.success("Stake Successful on Blockchain");
            handleSync();
        }
    }, [isstakeSuccess, stakeHash])

    if (!isOpen) return null;

    return (
        <div className="txMigaration_mainModal">
            <div className="tx_table_modalBox p-4" style={{ width: '850px', height: 'auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className='m-0' style={{ fontSize: '24px', fontWeight: '700' }}>Add Off-chain</h2>
                    <span className="cursor-pointer" onClick={onClose}><RxCross2 fontSize={25} /></span>
                </div>

                <div className='d-flex justify-content-center align-items-start gap-3'>
                    <div className='card p-3 rounded-lg border-0 shadow-sm' style={{ width: "60%", background: '#f8f9fa' }}>
                        <form>
                            {!type && <div className='input-container'>
                                <small>Select Type</small>
                                <select
                                    name='type'
                                    value={form.type}
                                    onChange={handleChange}
                                >
                                    <option value="validator">Validator</option>
                                    <option value="delegator">Delegator</option>
                                </select>
                            </div>}

                            {form.type === "validator" && (
                                <div className='input-container'>
                                    <small>Select Tier</small>
                                    <select
                                        name='tier'
                                        value={form.tier}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Tier 1 ($500)</option>
                                        <option value="2">Tier 2 ($1000)</option>
                                        <option value="3">Tier 3 ($5000)</option>
                                        <option value="4">Tier 4 ($10000)</option>
                                    </select>
                                </div>
                            )}

                            <div className='input-container'>
                                <small>Enter Wallet Address</small>
                                <input
                                    name='walletAddress'
                                    type='text'
                                    placeholder='Enter wallet address'
                                    value={form.walletAddress}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className='input-container'>
                                <small>Enter Invested Amount(USDT) {form.type === "validator" && "(Auto-filled)"}</small>
                                <input
                                    name='amount'
                                    type='number'
                                    placeholder='Enter Amount (USDT)'
                                    value={form.amount}
                                    onChange={handleChange}
                                    readOnly={form.type === "validator"}
                                />
                            </div>
                            <div className='d-flex justify-content-center align-items-start gap-3'>
                                <div className='input-container w-50'>
                                    <small>Select Bonus Range</small>
                                    <select
                                        name='bonusCat'
                                        value={form.bonusCat}
                                        onChange={handleChange}
                                    >
                                        <option value="1">1x</option>
                                        <option value="2">2x</option>
                                        <option value="3">3x</option>
                                    </select>
                                </div>
                                <div className='input-container w-50'>
                                    <small>Select Date of investment</small>
                                    <input
                                        name='startDate'
                                        type='date'
                                        value={form.startDate}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={handleSubmit}
                                className='blue-button w-100 mt-3'
                                disabled={!epochInfo?.[2] || loader}
                            >
                                {loader ? "Processing..." : epochInfo?.[2] ? "Confirm Stake" : "Wait for frozen time"}
                            </button>
                        </form>
                    </div>
                    <div style={{ width: "40%" }}>
                        <div className='card p-3 rounded-lg border-0 shadow-sm' style={{ background: '#f8f9fa' }}>
                            <p className='fw-bold mb-3'>Breakdowns</p>
                            <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <small className='text-muted'>Total Investment(USDT)</small>
                                <small className='fw-bold'>${form.amount || '0'}</small>
                            </div>
                            <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <small className='text-muted'>MForge Price(USD)</small>
                                <small className='fw-bold'>{mforgePrice ? `$${Number(formatEther(mforgePrice)).toFixed(5)}` : "-"}</small>
                            </div>
                            <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <small className='text-muted'>Principle Amount</small>
                                <small className='fw-bold'>{calculation?.principle ? `${Number(calculation?.principle)?.toFixed(4)} MFORGE` : "-"}</small>
                            </div>
                            <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <small className='text-muted'>Bonus Amount</small>
                                <small className='fw-bold'>{calculation?.bonus ? `${Number(calculation?.bonus)?.toFixed(4)} MFORGE` : "-"}</small>
                            </div>
                            <div className='mb-4 d-flex justify-content-between align-items-center'>
                                <small className='text-muted'>Starts From</small>
                                <small className='fw-bold'>{form.startDate ? new Date(form.startDate).toLocaleDateString() : "-"}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
